import { combineReducers } from "redux";

import serviceinclude from "../features/admin/services/serviceinclude/Slice";

import keybenefit from "../features/admin/services/keybenefit/Slice";

import bestfor from "../features/admin/services/bestfor/Slice";

import service from "../features/admin/services/service/Slice";

import common from "../features/admin/common/Slice";

const services = combineReducers({
  serviceinclude,
  keybenefit,
  bestfor,
  service,
  common,
});

export default services;
